import { rqClient } from "@/shared/api/instance";
import { useSession } from "@/shared/model/session";

export function useStoreBalance() {
  const { isAuthenticated } = useSession();

  return rqClient.useQuery(
    "get",
    "/api/v1/stores/balance",
    {},
    {
      enabled: isAuthenticated,
    },
  );
}
